import React from "react";
import "./CouponPopupStyle.scss";
import Emoiji from "../../common/assets/png/greatchoiceemoji.png"
import { useSelector } from "react-redux";
import { toggleCartView } from "../../common/features/cart/cartActions";
import { useDispatch } from "react-redux";
import { validateCouponClearmsg } from "../../common/features/restaurant/restaurantAction";


const CouponSuccessPopup = ({ open, onClose,couponDetails }:any) => {
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile)
  const attributes = couponDetails && couponDetails?.attributes ? JSON.parse(couponDetails?.attributes) : null;
  const dispatch=useDispatch();
  const currencySymbol =
  attributes?.currencyType === 'USD'
    ? '$'
    : attributes?.currencyType === 'IN'
    ? '₹'
    : '';
    

   const couponAmount= parseFloat(couponDetails?.offerRate)?.toFixed(2);
  if (!open) return null;


  return (
    <div className="coupon-overlay">
      <div className="coupon-popup">
        {/* Close Button */}
        {/* {
            isMobile && 
             <button className="close-btn" onClick={onClose}>
          ✕
        </button>
        } */}
       

        {/* Icon */}
        <div className="icon">
          <img
            src={Emoiji}
            alt="Success"
          />
        </div>

        {/* Content */}
        <h2 className="great-choice-text">Great Choice!</h2>

        <p className="geate-choice-coupunname-container">
          You saved <span className="coupon-discount-price">{currencySymbol}{couponAmount}</span> with coupon{" "}

          <span className="couponname-text">{couponDetails?.offerCode}</span>. Your discounted total is ready
          for checkout.
        </p>

        {/* CTA */}
        <button 
          className="cta-btn" 
          onClick={() => {
            onClose()
            dispatch(validateCouponClearmsg())
          }}
        >
          Back to Cart
        </button>
      </div>
    </div>
  );
};

export default CouponSuccessPopup;
